import c from "./lib/createApi";

/**
 * user는 로그인 후 유저 관련
 */
export default {
  gets: c("GET", "/v1/process", true), // [공정도 - 2] 공정도 전체 이름 조회
  create: c("POST", "/v1/process", true), // [공정도 - 1] 공정도 생성
  detail: c("GET", `/v1/process/:id`, true), // [공정도 - 5] 공정도 상세 조회
  detailPublicActive: c("GET", `/v1/process/publicActive/:id`, true), // [공정도 - 28] 공개 공정도 상세 조회
  put: c("PUT", `/v1/process/:id`, true), // [공정도 - 3] 공정도 수정
  delete: c("DELETE", `/v1/process/:id`, true), // [공정도 - 4] 공정도 삭제
  getProtocols: c("GET", `/v1/process/:id/protocol`, true), // [공정도 - 6] 내 상세 조회
  modify: c('PUT','/v1/process/:id/detail', true), //공정도 디테일 수정
  thumbnail: {
    get: c('GET', "/v1/process/:id/thumbnail", true), // 공정도 이미지 호출
    put: c('PUT', "/v1/process/:id/thumbnail", true), // 공정도 이미지 저장
  },
  thumbnailPublishing: c('GET', "/v1/process/:id/thumbnail/publishing", true), // 공정도 공개 이미지 호출
  processToTemplate: c('POST', "/v1/process/:id/template"), // 공정도를 템플릿으로 변경
  getProcessTemplate: c('GET', "/v1/process/template"), // process_type 이 TEMPLATE 인 공정도만 검색
  // 검색
  search: c("GET", "/v1/process/search", true), // [공정도 - 7] 공정도 검색
  publicSearch: c("GET", "/v1/process/searchPublishing", true), // [공정도 - 7] 공정도 검색
  // 기존 템플릿 조회 API 사용 여부는 확인 필요
  // 템플릿
  template: {
    gets: c("GET", "/v1/template", true), // [템플릿-1] 템플릿 조회
    paste: c("POST", "/v1/template/:id/apply", true), // [템플릿-3] 공정도에 템플릿 덮어씌우기
  },
  optionUser: {
    get: c("GET","/v1/process/:id/optionUser", true ),
    put: c("PUT","/v1/process/:id/optionUser", true ),
  },
  collaborator: {
    get: c('GET','/v1/process/collaborator', true),
    delete: c('DELETE','/v1/process/collaborator', true),
    add: c('POST','/v1/process/collaborator', true)
  },
  set : {
    protocol: c('POST','/v1/process/createProtocol', true),
  },
  log : {
    get: c( 'GET' , '/v1/process/:id/log' , true ) , 
    put: c( 'PUT' , '/v1/process/:id/log' , true ) , 
    getByLogId: c( 'GET' , '/v1/process/:id/logDetail' , true ) , 
    overWrite: c( 'PUT' , '/v1/process/logOverWrite' , true ) , 
  } , 
  release : { // 공개관련
    create: c('POST','/v1/process/release', true),      // 공개시
    get: c('GET','/v1/process/release', true),          // 공개시 작성한 메모, 공개범위 등 데이터를 불러옴.
    search: c('POST','/v1/process/releaseSearch', true), // 공개된 데이터 조회 (통합검색)
    getOptions: c('GET','/v1/process/releaseSearchOptions', true), // 검색시 사용할 Option list Return
    detail: c("GET", '/v1/process/releaseDetail/:id', true), // 공개 공정도 상세 조회 new (공개 테이블 분리 적용)
    getValidProtocols: c("GET", `/v1/process/validProtocols/:id`, true), // [공정도 - 27] 공개 프로토콜 조회
    releaseProtocolMatchSearch : c('POST','/v1/process/releaseProtocolMatchSearch', true), // 프로토콜에서 프로세스 연결을 위한 공개된 데이터 조회
    getThumbnail: c('GET', "/v1/process/:id/release/thumbnail", true), // [공정도 - 39] 공개 이미지 가져오기(공개 분리 이후)
    searchInnerReleaseProcess : c("GET", "/v1/process/searchInnerReleaseProcess", true), // [공정도 - 40] 공개 공정도 검색
    cancel: c("DELETE", `/v1/process/release/cancel/:id`, true), // [공정도 - 41] 공개 공정도 비공개전환
  },
  autoSave : { // 자동저장
    create : c("POST", "/v1/process/autoSave/create", true), // 공정도 수정시 로그 저장
  },
  deactivate : c('POST','/v1/process/deactivate', true), // 공정도 비활성화 (active => 1) (기존의 삭제 기능)
  callUtil: c('GET','/v1/process/callUtil', true),
};
